<template>
  <el-row>
    <el-row type="flex" justify="space-between" class="title-bar vertical-center-box" style="height:32px">
      <div class="vertical-center-box">
        <div :class="[selectedNode.type === 'obj' ? 'mr-r10': '', ' title-h4 bold']">이벤트 TOP</div>
        <el-select v-show="selectedNode.type !== 'obj'" v-model="chartType" @change="loadData()" class="mr-l16" style="width:60px">
          <el-option v-for="item in chartTypeList" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="chartLimit" class="mr-l4" style="width:50px">
          <el-option v-for="item in chartLimitList" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="vertical-center-box">
        <i class="fal fa-caret-square-up" style="cursor:pointer;font-size:16px;font-weight:bold;color:#777" @click="clickOpenStatsBoxButton"></i>
      </div>
    </el-row>
    <div v-loading="isLoading">
      <ul v-if="!isEmptyData" class="trigger-list-wrapper" style="height:180px;overflow-y:scroll">
        <li class="trigger-count-item" v-for="(item, index) in eventTopNList" :key="chartType === 'obj' ? item.objId : item.rscMixKey" @click="clickProgressBar(item)" :style="[{'cursor':'pointer'}, {'margin-bottom': getProgressBarMargin(index)}]">
          <el-row type="flex" justify="space-between" class="vertical-center-box" style="margin-bottom: 2px;">
            <div class="label" style="font-size:13px;font-weight:600;height:21px">
              <i v-show="item.selected" class="fas fa-check mr-r4"></i>
              {{item.label}}
            </div>
            <span class="count" style="font-size:13px;font-weight:600">{{convertValueByUnitData(item.eventCount, 'count')}}</span>
          </el-row>
          <el-row>
            <div style="display:flex;height:9px">
              <span v-for="eventlevel in item.eventCountList" :key="eventlevel.eventlevelId" :style="[ {'width': `${eventlevel.percentage}%` }, {'background-color': eventlevel.color}, {'margin-right': '1px'} ]"></span>
            </div>
          </el-row>
        </li >
      </ul>
      <div v-else class="empty_box">
        <span class="empty_text">데이터가 없습니다.</span>
      </div>
    </div>
  </el-row>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import EventHistStatMixins from '@/mixins/event/event-hist-stats';
import EventHistAPI from '@/api/event/event-hist';

export default {
  name: 'WEventTopBox',
  mixins: [EventHistStatMixins],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    currentFilterCount: {
      type: Number,
      default: 0,
    },
    filterList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      isEmptyData: true,
      chartType: 'obj',
      chartLimit: 5,
      chartTypeList: [
        {
          label: '장비',
          value: 'obj',
        },
        {
          label: '자원',
          value: 'rsc',
        },
      ],
      chartLimitList: [5, 10],
      eventTopNList: [],
    };
  },
  watch: {
    active: {
      handler(value) {
        if (!isNil(value) && value) {
          this.chartType = this.selectedNode.type === 'obj' ? 'rsc' : 'obj';
          this.loadData();
        }
      },
      immediate: true,
    },
    // chartType은 트리의 select가 변경되었을 때 감지하도록 한다.
    selectedNode(val) {
      if (!isNil(val) && !isNil(this.chartType)) {
        this.chartType = val.type === 'obj' ? 'rsc' : 'obj';
      }
      this.loadData();
    },
    analysisDateParams() {
      this.loadData();
    },
    chartLimit() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      if (!this.active) {
        return;
      }
      this.isLoading = true;
      const params = {
        treeType: this.selectedTreeType,
        type: this.selectedNode.type,
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
        chartType: this.chartType,
        chartLimit: this.chartLimit,
      };

      this.setEventHistStatsParams(params);
      EventHistAPI.getEventHistStatsGroupByObjTopN(params).then((response) => {
        const result = response.data;
        if (result.success) {
          this.isEmptyData = !(result.data.length > 0);
          this.setEventTopNData(result.data);
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    setEventTopNData(data) {
      const eventTopNData = cloneDeep(data);
      eventTopNData.forEach((item) => {
        const total = item.eventCount;

        if (this.chartType === 'obj') {
          item.selected = !isNil(this.filterList.filter((filter) => item.objId === filter.objId)[0]);
        } else {
          item.selected = !isNil(this.filterList.filter((filter) => item.rscMixKey === filter.rscMixKey)[0]);
        }
        item.label = this.chartType === 'obj' ? `[${item.objDefineName}] ${item.objName}` : item.rscMixKeyName;

        item.eventCountList.forEach((eventItem) => {
          eventItem.percentage = (eventItem.eventCount / total) * 100;
          eventItem.color = this.eventlevelInfo[eventItem.eventlevelId].eventlevelColorBg;
        });
      });

      this.eventTopNList = eventTopNData;
    },
    clickOpenStatsBoxButton() {
      this.$emit('click-open-stats-box-button');
    },
    clickProgressBar(item) {
      if (isNil(item.selected) || !item.selected) {
        if (this.currentFilterCount === 10) {
          this.$message('필터는 10개까지 가능합니다');
          return;
        }
        item.selected = true;
      } else {
        item.selected = false;
      }
      item.name = this.chartType === 'obj' ? item.objName : item.rscMixKeyName;
      item.type = this.chartType;
      this.$emit('set-event-hist-filter', item);
    },
    deleteEventHistFilter(filter) {
      if (!isNil(filter)) {
        if (filter.type === 'obj') {
          const tempFilter = this.eventTopNList.filter((item) => item.objId === filter.objId)[0];
          if (!isNil(tempFilter)) {
            this.eventTopNList.filter((item) => item.objId === filter.objId)[0].selected = false;
          }
        } else {
          const tempFilter = this.eventTopNList.filter((item) => item.rscMixKey === filter.rscMixKey)[0];
          if (!isNil(tempFilter)) {
            this.eventTopNList.filter((item) => item.rscMixKey === filter.rscMixKey)[0].selected = false;
          }
        }
      } else {
        this.eventTopNList.forEach((item) => {
          item.selected = false;
        });
      }
    },
    getProgressBarMargin(index) {
      if (index + 1 < this.eventTopNList.length) {
        return '4px';
      }
      return '0px';
    },
  },
};
</script>

<style lang="scss" scoped>
.empty_box {
  width: 100%;
  min-height: 180px;
  display: table;
  .empty_text {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/event/event-hist/components/EventTopBox.vue